import { UITypes } from "types"

import { parseDateField } from "utils/dateUtils"

import { AlertRuleConfiguration } from "./alertRules.types"
import { getRuleName } from "./alertRulesCatalog"
import { AlertRuleStatusCell } from "./AlertRuleStatusCell"

const alertRuleStatusOptions: UITypes.Option[] = [
  { label: "Active", value: "1" },
  { label: "Inactive", value: "0" },
]

export const alertRulesTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Name",
    type: "sort-search",
    name: "name",
    size: "big",
  },
  {
    title: "Active Thermostats",
    name: "triggered_devices_count",
    type: "sort",
    size: "small",
  },
  {
    title: "Status",
    name: "is_enabled",
    type: "select",
    options: alertRuleStatusOptions,
    size: "small",
    cellComponent: AlertRuleStatusCell,
  },
  {
    title: "Updated date",
    name: "updated_date",
    size: "small",
  },
]

export interface AlertRuleRowItem extends AlertRuleConfiguration {
  scope: "contractor" | "device"
  deviceId?: number
}

export const mapAlertRulesToTableRows = (
  rules?: AlertRuleConfiguration[],
  scope: "contractor" | "device" = "contractor",
) => {
  if (!rules?.length) return []

  return rules.map(
    (rule, index): UITypes.TableBodyRow =>
      ({
        name: { value: getRuleName(rule) },
        triggered_devices_count: { value: rule.triggered_devices_count ?? 0 },
        is_enabled: { value: rule.is_enabled ? "active" : "inactive" },
        updated_date: { value: parseDateField(rule.updated_at) },
        rowSettings: {
          id: index + 1,
          item: {
            ...rule,
            scope,
          } as AlertRuleRowItem,
        },
      }) as UITypes.TableBodyRow,
  )
}
